interface UmsInteractionResponse {
    [key: string]: any; // Replace with the actual response shape if known
}

const UMS_INTERACTION_URL =
    'https://u7rqsbyffc.execute-api.eu-central-1.amazonaws.com/prod/ums_popup_interactions';

export enum UMSContent {
    logoSrc = 'https://watch.dazn.com/default-assets/partnership-default.png',
    title = 'GERMAN PRICE RISE',
    description = 'German price rise user interactions report',
    inputLabel = 'Enter DaznID',
    buttonLabel = 'Enter'
}

export enum UMSInteractionLabels {
    TableHeader = 'User Interactions',
    DaznId = 'DAZN ID',
    PopupCount = 'No. of times user interacted',
    DismissCount = 'No. of times user dismissed the popup',
    CrossGrade = 'Did user opt for crossgrade',
    CrossGradePlan = 'Selected crossgrade plan',
    TimeDate = 'Time and Date when user crossgraded',
    Platform = 'Platform',
    ApplicationArea = 'Application Area',
    AnnualID = 'Zuora_8a1295258594917001859a78b29f67cc',
    InstalmentID = 'Zuora_8a129525853873990185808ee5e67af5',
    MonthID = 'Zuora_8a128aa885386ba701858083c6292192'
}

export const getUmsInteractions = async (
    daznId: string | null | undefined
): Promise<UmsInteractionResponse | null> => {
    // Validate inputs
    if (!daznId) {
        console.error('DAZN ID is required.');
        return null;
    }

    if (!UMS_INTERACTION_URL) {
        console.error('URL is required.');
        return null;
    }

    const data = {daznId};

    try {
        const response = await fetch(UMS_INTERACTION_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            console.error(`Error: Received status ${response.status}`);
            throw new Error('Error fetching UMS interactions.');
        }

        const responseData: UmsInteractionResponse = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error fetching UMS interactions:', error);
        return null; // Return null in case of error
    }
};
